const expandPainelButtonFormActions = {
  more: 'Ver mais',
  less: 'Ver menos'
};

export default expandPainelButtonFormActions;
